"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("../api/base");
var UploadcareFile_1 = require("../tools/UploadcareFile");
var isReadyPoll_1 = require("../tools/isReadyPoll");
var uploadFromObject = function (file, _a) {
    var publicKey = _a.publicKey, fileName = _a.fileName, baseURL = _a.baseURL, secureSignature = _a.secureSignature, secureExpire = _a.secureExpire, store = _a.store, cancel = _a.cancel, onProgress = _a.onProgress, source = _a.source, integration = _a.integration, retryThrottledRequestMaxTimes = _a.retryThrottledRequestMaxTimes, baseCDN = _a.baseCDN;
    return base_1.default(file, {
        publicKey: publicKey,
        fileName: fileName,
        baseURL: baseURL,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        cancel: cancel,
        onProgress: onProgress,
        source: source,
        integration: integration,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    })
        .then(function (_a) {
        var file = _a.file;
        return isReadyPoll_1.isReadyPoll({
            file: file,
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            onProgress: onProgress,
            cancel: cancel
        });
    })
        .then(function (fileInfo) { return new UploadcareFile_1.UploadcareFile(fileInfo, { baseCDN: baseCDN }); });
};
exports.default = uploadFromObject;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/uploadFile/uploadBase.js
// module id = 1253
// module chunks = 68